import moment from "moment";
import Constants from "../util/Constants";
import {ArrayUtil, P} from "oca-lib-web";
import DashboardDateUtil from "../util/DashboardDateUtil";
import { getGlobal } from 'reactn';
import { Cache } from 'aws-amplify';

export default class AppStoreConnectDataAccess {

    public static APPDOWNLOADS = "appDownloads";

    public static APPDOWNLOADS_INSTALLS = "installs";
    public static APPDOWNLOADS_SALES = "sales";
    public static APPDOWNLOADS_UNINSTALLS = "uninstalls";
    public static APPDOWNLOADS_UPGRADES = "upgrades";
    public static APPDOWNLOADS_ACTIVEDEVICES = "activeDevices";

    public static PRODUCT_TYPE_IDENTIFIER_NEW_IPHONE = "1";
    public static PRODUCT_TYPE_IDENTIFIER_NEW_UNIVERSAL = "1F";
    public static PRODUCT_TYPE_IDENTIFIER_NEW_IPAD = "1T";
    public static PRODUCT_TYPE_IDENTIFIER_REDOWNLOAD = "3";
    public static PRODUCT_TYPE_IDENTIFIER_UPDATE = "7";
    public static PRODUCT_TYPE_IDENTIFIER_INAPP_PURCHASE = "IA1";
    public static PRODUCT_TYPE_IDENTIFIER_INAPP_SUBSCRIPTION = "IA9";
    public static PRODUCT_TYPE_IDENTIFIER_INAPP_AUTORENEWSUBSCRIPTION = "IAY";

    public data:Array<AppStoreReport> = [];

    public async fetchData(dataSourceId:string, timeInterval:TimeInterval):Promise<any> {
        this.loadCacheIfAvailable();
        if (this.data.length > 0) {
            console.log(this.data);
            return P.resolve(true);
        }
        //return P.resolve(true);

        var self = this;
        return new Promise(async function(resolve, reject) {
            let input:ReportInput = {
                field: "getAppleReport",
                dataSourceId: dataSourceId,
                fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
                toDate: timeInterval.end,
                interval: DashboardDateUtil.getDateInterval(timeInterval.interval)
            };
            //let appleReport = await AWS.query(AppleReportQuery.GetAppleReport, {input: input});
            //let appleReport = await getGlobal().data.getAppStoreData(input);
            let appleReport = await getGlobal().dataManager.get("getAppStoreData", input);
            let newInstallsReport:Array<any> = [];
            let productIdentifiers = [AppStoreConnectDataAccess.PRODUCT_TYPE_IDENTIFIER_NEW_IPHONE, AppStoreConnectDataAccess.PRODUCT_TYPE_IDENTIFIER_NEW_IPAD, AppStoreConnectDataAccess.PRODUCT_TYPE_IDENTIFIER_NEW_UNIVERSAL,
                AppStoreConnectDataAccess.PRODUCT_TYPE_IDENTIFIER_INAPP_PURCHASE, AppStoreConnectDataAccess.PRODUCT_TYPE_IDENTIFIER_INAPP_SUBSCRIPTION, AppStoreConnectDataAccess.PRODUCT_TYPE_IDENTIFIER_INAPP_AUTORENEWSUBSCRIPTION];
            for (let productIdentifier of productIdentifiers) {
                newInstallsReport.push(... ArrayUtil.getItems(appleReport, "productTypeIdentifier", productIdentifier));
            }

            for (let appleReportItem of newInstallsReport) {
                self.data.push({
                    date: moment(appleReportItem.beginDate, "MM/DD/YYYY").format("YYYYMMDD"),
                    deviceType: Constants.APP_IOS,
                    installs: parseInt(appleReportItem.units),
                    sales: parseFloat(appleReportItem.customerPrice),
                    uninstalls: 0,
                    upgrades: 0,
                    activeDevices: 0
                });
            }
            console.log(self.data);
            self.cacheData();
            resolve(true);
        });
    }

    public loadCacheIfAvailable() {
        let cacheData = Cache.getItem("AppStore");
        console.log(cacheData);
        if (cacheData) {
            console.log("Loading AppStore from cache");
            this.data = cacheData;
        }
    }

    public cacheData() {
        Cache.setItem("AppStore", this.data);
    }

    public clearData() {
        this.data = [];
    }

    public clearCache() {
        Cache.removeItem("AppStore");
    }

    public static getMetricOptions() {
        return [AppStoreConnectDataAccess.APPDOWNLOADS_INSTALLS, AppStoreConnectDataAccess.APPDOWNLOADS_SALES, AppStoreConnectDataAccess.APPDOWNLOADS_UNINSTALLS,
            AppStoreConnectDataAccess.APPDOWNLOADS_UPGRADES, AppStoreConnectDataAccess.APPDOWNLOADS_ACTIVEDEVICES];
    }

    public static getXAxisOptions() {
        return [Constants.AXIS_DATE, "deviceType"];
    }
}